import Axios from 'axios';
import { store } from './store/state-loader.js'

// apiConfig.js
// Configuración de la API y portal cautivo
const dev = false, 
	basicURL = (dev) ? 'http://localhost:8001/blackfon-api/index.php?r=' : 'https://blackfon.mx/blackfon-api/index.php?r=',
	pcURI = (dev) ? 'http://localhost:8080' : 'https://cautivo.blackfon.mx';

async function portalCautivo(msisdn = null) {
	try {
		// SI ESTÁ LOGUEADO, REDIRIGE A PORTAL CAUTIVO CON LOGIN DE AUTOCREDENCIALES
		if (store.getters.isLogged) {
			const response = await _getAutoLoginCredentials();
			// SI response.status ES TRUE, REDIRIGE A PORTAL CAUTIVO CON LOGIN DE AUTOCREDENCIALES
			if(response.status){
				return _openBlank(msisdn, response.data)
			}
			// SI NO, SE RECOMIENDA NOTIFICAR AL CLIENTE QUE NO TIENE ACCESO O ALGO. 
		} else
		// SI NO, REDIRIGE A PORTAL CAUTIVO SIN LOGIN DE AUTOCREDENCIALES
			return _openBlank(msisdn)
	} catch (e) {
		console.error(e)
	}
}

async function _getAutoLoginCredentials() {
	const response = await Axios.get('account/autocredentials')
	console.log('_getAutoLoginCredentials.response', response)
	return response;
}

function _openBlank(msisdn = null, options = {}) {
	let url = pcURI;

	if (typeof msisdn === 'string' && msisdn.trim() !== '') {
		msisdn = msisdn.replace(/[^0-9]/g, '');
		url += `/view?msisdn=${msisdn}`;
	} else {
		url += `/view`;
	}

	if ('id' in options && 'beacon' in options) {
		url += `${url.includes('?') ? '&' : '?'}id=${options.id}`;
		url += `${url.includes('?') ? '&' : '?'}beacon=${options.beacon}`;
	}
	window.open(url, '_blank');
	return true;
}

export { basicURL, pcURI, portalCautivo }